import {Stack, IconButton, Tooltip} from '@mui/material'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import EditButton from '../../shared/UI/EditButton'

interface EditControlsProps {
  readonly isEditMode: boolean;
  readonly onToggleEditMode: () => void;
  readonly onResetSections?: () => void;
  readonly editDataTestId?: string;
  readonly resetDataTestId?: string;
}

function EditControls({
                        isEditMode,
                        onToggleEditMode,
                        onResetSections,
                        editDataTestId = 'EnhancementReporting-Edit-Btn',
                        resetDataTestId = 'EnhancementReporting-Reset-Btn'
                      }: EditControlsProps) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {isEditMode && onResetSections && (
        <Tooltip title="Reset sections to default" placement="bottom">
          <IconButton
            onClick={onResetSections}
            color="primary"
            data-testid={resetDataTestId}
          >
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      )}
      <EditButton
        onClick={onToggleEditMode}
        isEditMode={isEditMode}
        dataTestId={editDataTestId}
      />
    </Stack>
  )
}

export default EditControls